module.exports = __webpack_public_path__ + "static/media/2-6.f16001e5.mp3";